import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

export enum SearchBackgroundVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const searchBackgroundVariants: Variants = {
    [SearchBackgroundVariant.Hidden]: {
        opacity: 0.8,
    },
    [SearchBackgroundVariant.Show]: {
        opacity: 1,
    },
};

export const searchBackgroundCircleVariants: Variants = {
    [SearchBackgroundVariant.Hidden]: {
        scale: 0,
    },
    [SearchBackgroundVariant.Show]: {
        scale: 25,
    },
};

export const searchBackgroundTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.4,
};

export enum PrefixActionVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const prefixActionVariants: Variants = {
    [PrefixActionVariant.Hidden]: {
        opacity: 0,
        scale: 0,
    },
    [PrefixActionVariant.Show]: {
        opacity: 1,
        scale: 1,
    },
};

export enum MainChildVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const mainChildVariants: Variants = {
    [MainChildVariant.Hidden]: {
        opacity: 0,
        translateY: '100%',
    },
    [MainChildVariant.Show]: {
        opacity: 1,
        translateY: '0%',
    },
};

export const mainChildTransition: Transition = {
    ease: 'easeInOut',
    duration: 0.4,
};

export enum SuffixActionVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const suffixActionVariants: Variants = {
    [SuffixActionVariant.Hidden]: {
        opacity: 0,
    },
    [SuffixActionVariant.Show]: {
        opacity: 1,
    },
};

export const suffixActionTransition: Transition = {
    ease: 'easeInOut',
    duration: 0.4,
};
